// store/modules/StudentManagement.js
import Axios from "@/api/BaseAxios";
import { API_PDP_STUDENT_LIST } from "@/constants/APIUrls";

export default {
  namespaced: true,
  state: {
    addEditViewModal: {
      type: "", // add || edit || view
      show: false,
      studentID: "",
    },
    deleteModal: {
      studentID: "",
      Delete: false,
    },
    show: false,
    Delete: false,
    student_list: [],
  },
  getters: {
    getShow: (state) => state.addEditViewModal.show,
    getDelete: (state) => state.deleteModal.Delete,
    getStudentList: (state) => state.student_list,
  },
  mutations: {
    TOGGLE_MODAL(state, obj) {
      if (obj.show) {
        state.addEditViewModal.type = obj.type;
        state.addEditViewModal.studentID = obj.id ? obj.id : "";
      }
      state.addEditViewModal.show = obj.show;
    },
    TOGGLE_DELETE_MODAL(state, obj) {
      if (obj.Delete) {
        state.deleteModal.studentID = obj.id ? obj.id : "";
      }
      state.deleteModal.Delete = obj.Delete;
    },
    SET_STUDENT_LIST(state, list) {
      state.student_list = list;
    },
  },
  actions: {
    toggleModal({ commit }, obj) {
      commit("TOGGLE_MODAL", obj);
    },
    toggleDeleteModal({ commit }, obj) {
      commit("TOGGLE_DELETE_MODAL", obj);
    },
    fetchStudentList({ commit }, formData) {
      return new Promise((resolve, reject) => {
        Axios.request_GET(
          API_PDP_STUDENT_LIST,
          formData,
          {},
          (res) => {
            commit("SET_STUDENT_LIST", res.data.student_list);
            resolve(res.data.student_list);
          },
          (err) => {
            console.error(err);
            reject(err);
          },
          false
        );
      });
    },
  },
  };
